module.exports = "<div class=\"page\"> </div>\n\n\n<ng-container *ngFor=\"let post of posts; let i = index\">\n  <div class=\"form-container\">\n    <div class=\"row columns\">\n      <label>お名前\n        <p>{{ post.name }}</p>\n      </label>\n      <label>内容\n        <pre>{{ post.description }}</pre>\n      </label>\n    </div>\n  </div>\n</ng-container>\n\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/homePC/angular-comp/The-Top/src/app/form/list/list.component.html
// module id = ../../../../../src/app/form/list/list.component.html
// module chunks = main